import { render } from "./WhiteBlock.vue?vue&type=template&id=7425530e&scoped=true"
const script = {}

import "./WhiteBlock.vue?vue&type=style&index=0&id=7425530e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7425530e"]])

export default __exports__